import { Navigate, useRoutes } from "react-router-dom"

import Panel from "../pages/private/Panel"
import Login from "../pages/public/Login"
import { PrivateRoute } from "./PrivateRoute"
import { PublicRoute } from "./PublicRoute"
import ReplenishmentPage from "pages/private/NewReplenishment"
import OperatorPanel from "pages/private/OperatorPanel"
import Replenishing from "pages/private/NewReplenishment/Replenishing"
import DashReplenishment from "pages/private/Dashboard/DashReplenishment"
import Balance from "pages/private/Balance"
import Replenishment from "pages/private/Replenishment"
import Stockout from "pages/private/Stockout"
import MoveSkuReplenishing from "pages/private/NewReplenishment/MoveSku"
import EspecificSkuReplenishing from "pages/private/NewReplenishment/EspecificSku"
import Config from "pages/private/Config"
import { Skus } from "pages/private/Config/Skus"
import { Markets } from "pages/private/Config/Markets/Index"
import SplitBoxReplenishing from "pages/private/NewReplenishment/SkuMigrate"
import Batches from "pages/private/Config/Batches"
import { Scanner } from "pages/private/Config/Scanner"

const Routes = () => {
  return useRoutes([
    {
      path: "/login",
      element: <PublicRoute component={Login} />,
    },
    {
      path: "/painel-de-admin",
      element: <PrivateRoute component={Panel} rules={[]} />,
      children: [
        {
          path: "dashboard",
          element: <PrivateRoute component={DashReplenishment} rules={[]} />,
        },
        {
          path: "balanco",
          element: <PrivateRoute component={Balance} rules={[]} />,
        },
        {
          path: "sem-estoque",
          element: <PrivateRoute component={Stockout} rules={[]} />,
        },
        {
          path: "abastecimentos",
          element: <PrivateRoute component={Replenishment} rules={[]} />,
        },
        {
          path: "configuracoes",
          element: <PrivateRoute component={Config} rules={[]} />,
        },
        {
          path: "configuracoes/mercados",
          element: <PrivateRoute component={Markets} rules={[]} />,
        },
        {
          path: "configuracoes/skus",
          element: <PrivateRoute component={Skus} rules={[]} />,
        },
        {
          path: "configuracoes/lotes",
          element: <PrivateRoute component={Batches} rules={[]} />,
        },
        {
          path: "configuracoes/scanner",
          element: <PrivateRoute component={Scanner} rules={[]} />,
        },
      ],
    },
    {
      path: "painel-de-operador",
      element: <PrivateRoute component={OperatorPanel} rules={[]} />,
      children: [
        {
          path: "abastecimento",
          element: <PrivateRoute component={ReplenishmentPage} rules={[]} />,
        },
        {
          path: "sku/:skuId",
          element: <PrivateRoute component={Replenishing} rules={[]} />,
        },
        {
          path: "sku/:skuId/move",
          element: <PrivateRoute component={MoveSkuReplenishing} rules={[]} />,
        },
        {
          path: "sku/especific",
          element: <PrivateRoute component={EspecificSkuReplenishing} rules={[]} />,
        },
        {
          path: "sku/split-box",
          element: <PrivateRoute component={SplitBoxReplenishing} rules={[]} />,
        },
        {
          path: "*",
          element: <Navigate to="abastecimento" />,
        },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/login" />,
    },
  ])
}

export default Routes
